/**
 * How long a screen took to show what a callback delivered. The values are invented single words so a
 * Bugfender text search (whole words, any order) counts each bucket.
 */
export enum PaintVerdict {
	Paint1s = 'paint1s',
	Paint3s = 'paint3s',
	PaintSlow = 'paintslow',
	Stuck = 'gpstuck',
	/** Not painted, but the tab was hidden: phones throttle hidden tabs' timers, so this is no regression signal. */
	Hidden = 'gphidden',
}
